import { useTranslation } from 'react-i18next';

import { capitalizeFirstLetter } from '@src/global/utils/StringService';
import { getFirstAndLastName } from './helpers';
import { subscriptionsByUid } from '@src/global/store/slices/subscription/subscriptionSlice';

export const ProfileInformation = ({
  subscription,
}: {
  subscription: subscriptionsByUid;
}) => {
  const { t } = useTranslation();

  const { firstName, lastName } = getFirstAndLastName(
    subscription?.billingInfo?.name
  );

  return (
    <div>
      <span className="subscription__title">
        {t('subDetails.sub.profileInfo.title')}
      </span>
      <div className="sub-information">
        <div className="sub-information__column-container">
          <div className="sub-information__column">
            <span className="sub-information__text_gray">
              {t('subDetails.sub.profileInfo.firstName')}
            </span>
            <span className="sub-information__text_black">
              {capitalizeFirstLetter(firstName)}
            </span>
          </div>
          <div className="sub-information__column">
            <div className="profile-info__padding-left">
              <span className="sub-information__text_gray">
                {t('subDetails.sub.profileInfo.lastName')}
              </span>
              <span className="sub-information__text_black">
                {capitalizeFirstLetter(lastName)}
              </span>
            </div>
          </div>
        </div>
        <div className="sub-information__column-container">
          <div className="sub-information__column">
            <div className="profile-info__padding-top">
              <span className="sub-information__text_gray">
                {t('subDetails.sub.profileInfo.emailAddress')}
              </span>
              <span className="sub-information__text_black">
                {subscription?.userEmail}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
